import { render, staticRenderFns } from "./AddFunctionBox.vue?vue&type=template&id=236fe3ee&"
import script from "./AddFunctionBox.vue?vue&type=script&lang=js&"
export * from "./AddFunctionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports